import { Injectable } from '@angular/core';
import { WebServicesService } from '../webservices.service';


import { AccountApiService } from './account.api';
import { CustomerApiService } from './customer.api';
import { DestinationApiService } from './destination.api';
import { ArticleApiService } from './article.api';
import { ArticleTypeApiService } from './articletype.api';
import { DocApiService } from './doc.api';
import { StatApiService } from './stat.api';
import { DepartmentApiService } from './department.api';
import { StockMovementApiService } from './stockmovement.api';
import { DocDownloadApiService } from './docdownload.api';

@Injectable()
export class ApiService {
    static CACHEKEY_CUSTOMERS = 'customers';
    static CACHEKEY_CUSTOMERS_SELECT = 'customers-select';
    static CACHEKEY_DESTINATIONS = 'destinations';
    static CACHEKEY_DESTINATIONS_SELECT = 'destinations-select';
    static CACHEKEY_ARTICLES = 'articles';
    static CACHEKEY_ARTICLES_SELECT = 'articles-select';
    static CACHEKEY_ARTICLE_TYPES = 'articletypes';
    static CACHEKEY_STOCKMOVEMENTS = 'stockmovements';
    static CACHEKEY_DOCS = 'docs';
    static CACHEKEY_STATS = 'stat';

    private coldCache = true;

    constructor(
        private _ws: WebServicesService,
    ) { }

    account = () => new AccountApiService(this._ws);

    article = () => new ArticleApiService(this._ws);

    articleType = () => new ArticleTypeApiService(this._ws);

    customer = () => new CustomerApiService(this._ws);

    department = () => new DepartmentApiService(this._ws);

    destination = () => new DestinationApiService(this._ws);

    doc = () => new DocApiService(this._ws);
    docDownload = () => new DocDownloadApiService(this._ws);

    stat = () => new StatApiService(this._ws);

    stockMovement = () => new StockMovementApiService(this._ws);

    // putUploadPhoto(file: GenericFile) {
    //     return this._ws.putJson(this._urls.putUploadPhoto(), file);
    // }
}
